import { produce } from 'immer';
import {
  GET_CLIENT_PERSISTED_STATE_FAILURE,
  GET_CLIENT_PERSISTED_STATE_SUCCESS,
  SET_CLIENT_PERSISTED_STATE_SUCCESS,
  GET_CLIENT_PERSISTED_STATE_BLOB_NOT_FOUND_FAILURE
} from './actions';
import { ClientPersistedState, ClientPersistedStateAction } from './clientpersistedstate-types';

export default function clientPersistedState(existingState: ClientPersistedState = {}, action: ClientPersistedStateAction) {
  if (!action) {
    return existingState;
  }

  return produce(existingState, (state: ClientPersistedState) => {
    const { type, payload } = action;

    switch (type) {
      case GET_CLIENT_PERSISTED_STATE_SUCCESS:
      case SET_CLIENT_PERSISTED_STATE_SUCCESS:
        return { ...state, ...payload };

      case GET_CLIENT_PERSISTED_STATE_BLOB_NOT_FOUND_FAILURE:
        return payload;

      case GET_CLIENT_PERSISTED_STATE_FAILURE:
      default:
        return state;
    }
  });
}
